<template>
  <!-- PROPERTY YEAR -->
  <validation-observer
    v-slot="propertyYearObserver"
    key="year"
    slim
  >
    <form-section
      id="property-year"
      v-bind="propertyYearObserver"
      :validated="formObserver.validated"
    >
      <form-row
        label="Approximately what year was your property built?"
        :error="formObserver.validated && !propertyYearObserver.valid"
      >
        <validation-provider
          v-slot="{ errors, failed }"
          name="Property Year"
          :vid="`${stepId}_property-year`"
          slim
          rules="propertyYear"
        >
          <qz-number-input
            v-model.number="questionData.propertyYear"
            :error-messages="errors"
            :error="failed"
            placeholder="e.g. 1975"
            :without-separators="true"
            :maxlength="inputCharsLimiters.YEAR"
            :data-test="snakeCase(questionFields.propertyYear)"
          />
        </validation-provider>
      </form-row>
      <help-text
        :error="formObserver.validated && !propertyYearObserver.valid"
      >
        <p>
          This can be found on your mortgage valuation or Home Buyer Report.
        </p>
      </help-text>
    </form-section>
  </validation-observer>
</template>

<script>
import QuestionBase from '@/components/questions/Base.vue';

export default {
  name: 'question-property-year',
  extends: QuestionBase,
  data () {
    return {
      fields: ['propertyYear'],
    };
  },
};
</script>
